import T from 'prop-types';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Context = /*#__PURE__*/createContext();

function useZIndex(fallback = 1) {
  var _useContext;

  return (_useContext = useContext(Context)) !== null && _useContext !== void 0 ? _useContext : fallback;
}

function ZIndexProvider({
  children,
  value
}) {
  const outerIndex = useZIndex(0);
  const innerIndex = useMemo(() => {
    if (value) {
      return value;
    }

    return outerIndex + 1;
  }, [outerIndex, value]);
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: innerIndex,
    children: children
  });
}

ZIndexProvider.propTypes = {
  children: T.node.isRequired,
  value: T.number
};
export { ZIndexProvider, useZIndex };